import { createSkeletonElement } from '@trainline/react-skeletor'

const style = () => ({
  color: 'transparent',
  background:
    'linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2))',
})

export default type => createSkeletonElement(type, style)



// WEBPACK FOOTER //
// ./src/helpers/tomb.ts